const colors = {
  textColor: "#212529", // Black color for

  light_text: "#212529",
  light_primary: "#009EFB",
  light_light_primary: "#cfecfe",
  light_secondary: "#54667A",
  light_tertiary: "#f2f7f8",
  light_theme_gradient: "#14496e",
  light_background: "#ffffff",
  // muls theme color
  light_login_theme_gradient: "linear-gradient(154deg, #96dac76e 0, #00b29c 100%);",

  dark_text: "#b2b9bf",
  dark_primary: "#001f31",
  dark_secondary: "#C1DAF5",
  dark_tertiary: "#323743",
  dark_theme_gradient: "linear-gradient(to right, #001F31 0%, #0088D6 100%)",
  dark_background: "#272b34",
  // muls theme color
  dark_login_theme_gradient: "linear-gradient(154deg, #2c3e506e 0%, #34495e 100%);",

  yellow_text: "#212529",
  yellow_primary: "#FBA700",
  yellow_secondary: "#85785F",
  yellow_tertiary: "#F5F1EB",
  yellow_theme_gradient: "linear-gradient(to right, #FF9900 0%, #FF9900 100%)",
  yellow_background: "#ffffff",
  // muls theme color
  yellow_login_theme_gradient: "linear-gradient(154deg, #f9d4236e 0%, #ff4e50 100%);",

  pink_text: "#212529",
  pink_primary: "#D530B4",
  pink_secondary: "#8B7186",
  pink_tertiary: "#F5EBF3",
  pink_theme_gradient: "linear-gradient(to right, #D530B4 0%, #FFA4ED 100%)",
  pink_background: "#ffffff",
  // muls theme color
  pink_login_theme_gradient: "linear-gradient(154deg, #ff9a9e6e 0%, #fad0c4 100%);",
};

export default colors;